import { Button } from "antd";
import React from "react";

export default function ApproveButton({ handleApprove, isPatientDropdownEmpty, isSettingPatientId, isApproved, isApproving, breakdownStatus }) {
  return (
    <Button
      type="primary"
      onClick={handleApprove}
      disabled={breakdownStatus !== "pending" || isPatientDropdownEmpty || isSettingPatientId}
      style={{
        backgroundColor:
          breakdownStatus === "approved" || isApproved
            ? "rgba(4, 201, 0, 0.1)"
            : (breakdownStatus !== "approved" && isPatientDropdownEmpty) || breakdownStatus === "processing" || isSettingPatientId
            ? "#F5F5F5"
            : "#6B43B5",
        color:
          breakdownStatus === "approved" || isApproved
            ? "#04C900"
            : (breakdownStatus !== "approved" && isPatientDropdownEmpty) || breakdownStatus === "processing" || isSettingPatientId
            ? "#848696"
            : "white",
        border:
          (breakdownStatus !== "approved" && isPatientDropdownEmpty) || breakdownStatus === "processing" || isSettingPatientId
            ? "1px solid #d9d9d9"
            : breakdownStatus === "approved" || isApproved
            ? "none"
            : "1px solid #6B43B5",
        padding: "20px 50px",
        marginLeft: "auto",
        display: "flex",
        alignItems: "center",
        gap: 10,
      }}
      className={`${isApproved ? "approved-button" : ""}`}
    >
      {isApproving ? "Loading" : breakdownStatus === "processing" || breakdownStatus === "pending" ? "Approve All" : "Approved"}
    </Button>
  );
}
